import { action, makeObservable, observable } from 'mobx';
import { IHost } from 'stores/host/HostStore';

export interface IHostSearch extends IHost {
    id: string;
}

export default class HostHistoryStore {
    hostSearch = {
        id: '',
        hostname: '',
        last_update_on: new Date(),
        hostId: ''
    };

    constructor(hostSearch: IHostSearch) {
        makeObservable(this, {
            hostSearch: observable,
            update: action
        });

        this.update(hostSearch);
    }

    update(hostSearch: IHostSearch) {
        this.hostSearch = {
            ...this.hostSearch,
            ...hostSearch
        };
    }
}
